import React, { PureComponent, lazy, Suspense } from "react";

// import {VideoStage} from "playkit-video-stage";
import "playkit-video-stage/bundle/styles.css";
import "../stylesheets/lightboxContent.scss";

import LightboxHeader from "./immersiveLightboxHeader.js";
import { PlayIconSvg } from './playIconSvg';
import { addEscCloseEventToDocument } from './playkitMods'
import Skeleton from './skeleton';

const MyVideoStage = lazy(() => import('./my-video-stage'))

export default class ImmersiveLightbox extends PureComponent {
  constructor(props) {
    super(props);
    this.videoRef = null
    this.setVideoStageRef = this.setVideoStageRef.bind(this)
    this.onClose = this.onClose.bind(this)
    this.closeWithEsc = this.closeWithEsc.bind(this)
    this.state = { visible: false }
  }

  setVideoStageRef(el) {
    this.videoRef = el
  }

  componentDidMount() {
    addEscCloseEventToDocument(this.closeWithEsc)
  }

  open(options) {
    this.videoRef.setState({ ...options, visible: true }, () => {
      this.setState({ visible: true })
    })
  }

  show() {
    this.setState({ visible: true }, () => {
      if (this.videoRef) {
        this.videoRef.setState({ visible: true })
      }
    })
  }

  onClose() {
    this.setState({ visible: false }, () => {
      this.videoRef.onClose()
    })

  }

  closeWithEsc() {
    if (this.state.visible) {
      this.onClose();
    }
  }

  render() {
    let visibleClass = "immersive-lightbox immersive-lightbox--" + (this.state.visible ? 'show' : 'hidden')
    return (
      <div className={visibleClass}>
        <div>
          <PlayIconSvg />
          <LightboxHeader onClose={this.onClose} />
          <Suspense fallback={<Skeleton />}>
            <MyVideoStage
              {...this.props}
              ref={this.setVideoStageRef}
            />
          </Suspense>
        </div>
      </div>
    )
  }
}
